import { render, staticRenderFns } from "./ExtendedServices.vue?vue&type=template&id=5615e186&scoped=true&"
import script from "./ExtendedServices.vue?vue&type=script&lang=js&"
export * from "./ExtendedServices.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedServices.vue?vue&type=style&index=0&id=5615e186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5615e186",
  null
  
)

export default component.exports